import { type ToastData, useToast } from '@carvana/ds-toast';
import { useCallback, useEffect, useRef } from 'react';

export default function useReplaceToast() {
  const { addToast, clearAllToasts } = useToast();
  const addToastRef = useRef(addToast);
  const clearAllToastsRef = useRef(clearAllToasts);

  useEffect(() => {
    addToastRef.current = addToast;
    clearAllToastsRef.current = clearAllToasts;
  }, [addToast, clearAllToasts]);

  return useCallback((toast: Omit<ToastData, 'id'>) => {
    clearAllToastsRef.current();

    return addToastRef.current(toast);
  }, []);
}
